import script from "./AdminSchoolEnrollments.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSchoolEnrollments.vue?vue&type=script&setup=true&lang=js"

import "./AdminSchoolEnrollments.vue?vue&type=style&index=0&id=3006e7dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3006e7dc"]])

export default __exports__